// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estrutura geral */
.login-wrapper {
  display: flex;
  min-height: 100vh;
  background: #ffffff;
}

/* Coluna esquerda */
.login-left {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 12px;
  margin: 20px;
}

.login-logo {
  display: block;
  margin: 0 auto;        /* Centraliza horizontalmente */
  max-width: 200px;      /* Tamanho máximo no desktop */
  width: 100%;           /* Faz o logo ocupar 100% até o limite do max-width */
  height: auto;          /* Mantém a proporção */
}

.welcome-text {
  text-align: left;
  font-size: 22px;
  font-weight: 600;
}

.ola {
  font-size: 24px;
  color: #222;
}

.bem-vindo {
  margin: 0;
  color: #0a1a2f;
  font-weight: bold;
}

/* Coluna direita */
.login-right {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-box {
  background: #fff;
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.login-title {
  margin-bottom: 4px;
  font-weight: 600;
  color: #222;
}

.login-subtitle {
  display: block;
  margin-bottom: 24px;
  color: #666;
}

/* Botão */
.login-button {
  background: black;
  border: none;
  font-weight: bold;
  border-radius: 30px;
  height: 55px;       /* altura maior para combinar com os inputs */
  font-size: 16px;    /* texto maior */
}

.login-button:hover {
  background: #00000082 !important;
}

/* Responsivo */
@media (max-width: 768px) {
  .login-wrapper {
    flex-direction: column;
  }

  /*  Esconde o lado esquerdo no celular */
  .login-left {
    display: none;
  }

  .login-right {
    flex: 1 1;
    padding: 20px;
  }

  .login-box {
    width: 100%;
    max-width: 100%;
    border-radius: 0;
    box-shadow: none;
    min-height: 82vh; /* ocupa a tela toda */
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

/* Ajuste geral dos inputs */
.login-box .ant-input,
.login-box .ant-input-password {
  height: 50px;        /* altura maior */
  font-size: 16px;     /* aumenta o texto */
  border-radius: 8px;  /* cantos mais arredondados */
  padding: 0 15px;     /* espaço interno */
}

/* Garante consistência no ícone do campo senha */
.login-box .ant-input-password .ant-input {
  height: 50px;
  font-size: 16px;
}

/* Telas grandes */
@media (min-width: 1024px) {
  .login-logo {
    max-width: 220px;
  }
}

/* Tablets */
@media (max-width: 768px) {
  .login-logo {
    max-width: 180px;
  }
}

/* Celulares pequenos */
@media (max-width: 480px) {
  .login-logo {
    max-width: 150px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc,SAAS,+BAA+B;EACtD,gBAAgB,OAAO,8BAA8B;EACrD,WAAW,YAAY,qDAAqD;EAC5E,YAAY,WAAW,uBAAuB;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,YAAY,QAAQ,6CAA6C;EACjE,eAAe,KAAK,gBAAgB;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA,wCAAwC;EACxC;IACE,aAAa;EACf;;EAEA;IACE,SAAO;IACP,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB,EAAE,sBAAsB;IACxC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,4BAA4B;AAC5B;;EAEE,YAAY,SAAS,iBAAiB;EACtC,eAAe,MAAM,oBAAoB;EACzC,kBAAkB,GAAG,6BAA6B;EAClD,eAAe,MAAM,mBAAmB;AAC1C;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,YAAY;AACZ;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Estrutura geral */\r\n.login-wrapper {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  background: #ffffff;\r\n}\r\n\r\n/* Coluna esquerda */\r\n.login-left {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  border-radius: 12px;\r\n  margin: 20px;\r\n}\r\n\r\n.login-logo {\r\n  display: block;\r\n  margin: 0 auto;        /* Centraliza horizontalmente */\r\n  max-width: 200px;      /* Tamanho máximo no desktop */\r\n  width: 100%;           /* Faz o logo ocupar 100% até o limite do max-width */\r\n  height: auto;          /* Mantém a proporção */\r\n}\r\n\r\n.welcome-text {\r\n  text-align: left;\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n}\r\n\r\n.ola {\r\n  font-size: 24px;\r\n  color: #222;\r\n}\r\n\r\n.bem-vindo {\r\n  margin: 0;\r\n  color: #0a1a2f;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Coluna direita */\r\n.login-right {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n}\r\n\r\n.login-box {\r\n  background: #fff;\r\n  padding: 40px 30px;\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 24px rgba(0,0,0,0.08);\r\n  width: 100%;\r\n  max-width: 400px;\r\n  text-align: center;\r\n}\r\n\r\n.login-title {\r\n  margin-bottom: 4px;\r\n  font-weight: 600;\r\n  color: #222;\r\n}\r\n\r\n.login-subtitle {\r\n  display: block;\r\n  margin-bottom: 24px;\r\n  color: #666;\r\n}\r\n\r\n/* Botão */\r\n.login-button {\r\n  background: black;\r\n  border: none;\r\n  font-weight: bold;\r\n  border-radius: 30px;\r\n  height: 55px;       /* altura maior para combinar com os inputs */\r\n  font-size: 16px;    /* texto maior */\r\n}\r\n\r\n.login-button:hover {\r\n  background: #00000082 !important;\r\n}\r\n\r\n/* Responsivo */\r\n@media (max-width: 768px) {\r\n  .login-wrapper {\r\n    flex-direction: column;\r\n  }\r\n\r\n  /*  Esconde o lado esquerdo no celular */\r\n  .login-left {\r\n    display: none;\r\n  }\r\n\r\n  .login-right {\r\n    flex: 1;\r\n    padding: 20px;\r\n  }\r\n\r\n  .login-box {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    border-radius: 0;\r\n    box-shadow: none;\r\n    min-height: 82vh; /* ocupa a tela toda */\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n/* Ajuste geral dos inputs */\r\n.login-box .ant-input,\r\n.login-box .ant-input-password {\r\n  height: 50px;        /* altura maior */\r\n  font-size: 16px;     /* aumenta o texto */\r\n  border-radius: 8px;  /* cantos mais arredondados */\r\n  padding: 0 15px;     /* espaço interno */\r\n}\r\n\r\n/* Garante consistência no ícone do campo senha */\r\n.login-box .ant-input-password .ant-input {\r\n  height: 50px;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Telas grandes */\r\n@media (min-width: 1024px) {\r\n  .login-logo {\r\n    max-width: 220px;\r\n  }\r\n}\r\n\r\n/* Tablets */\r\n@media (max-width: 768px) {\r\n  .login-logo {\r\n    max-width: 180px;\r\n  }\r\n}\r\n\r\n/* Celulares pequenos */\r\n@media (max-width: 480px) {\r\n  .login-logo {\r\n    max-width: 150px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
